module.exports = __webpack_public_path__ + "a768e7de/img/copy-icon.408fdb2d.svg";